import { useContext } from 'react'
import { useStore } from 'zustand'
import { useShallow } from 'zustand/react/shallow'
import { StoreContext } from 'src/components/storeProvider'
import type { AllSlice } from 'src/store/types'

interface useStoreInContextOptType {
  shallow: boolean
}

function useStoreInContext<T>(selector: (state: AllSlice) => T, opt?: useStoreInContextOptType) {
  const store = useContext(StoreContext)

  if (!store) {
    throw new Error('Missing StoreProvider')
  }

  if (opt?.shallow === undefined) {
    opt = {
      ...opt,
      shallow: true,
    }
  }

  return useStore(store, opt.shallow ? useShallow(selector) : selector)
}

export default useStoreInContext
